import type { Theme } from '@mui/material/styles';

const getMuiInputBase = () => ({
  styleOverrides: {
    root: ({ theme }: { theme: Theme }) => ({
      '&.Mui-disabled': {
        color: theme.palette.semantic.text.placeholder,
      },
      // icons
      '& svg': {
        fill: theme.palette.semantic.text.primary,
      },
      '&.Mui-disabled svg': {
        fill: theme.palette.semantic.text.placeholder,
      },
      '&.Mui-error svg': {
        fill: theme.palette.semantic.ui.critical,
      },
      lineHeight: '20px',
      border: 'none',
    }),
    input: ({ theme }: { theme: Theme }) => ({
      paddingLeft: 12,
      fontSize: theme.typography.h6.fontSize,
      minHeight: 20,
      padding: '10px 0 9px',
      background: theme.palette.semantic.surface.default,
      height: 20,
      '&.MuiInputBase-input': {
        background: 'inherit',
      },
      '&.Mui-disabled': {
        pointerEvents: 'all',
        cursor: 'not-allowed',
        background: theme.palette.semantic.background.default,
      },
      '&.Mui.readOnly': {
        background: 'transparent',
      },
    }),
    // MUI v5 calculates the height of the textarea element
    // based on number of rows and sets it as inline style.
    // To override this behavior we need to set height to auto
    inputMultiline: {
      height: 'auto !important',
    },
  },
});

export default getMuiInputBase;
